export default __webpack_public_path__ + "static/media/fire3.90177e08.png";